/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum BloodManagementViewerAliases {
  BLOOD_MANAGEMENT_CONTENT_PANEL = 'blood-management-content-panel',
  BLOOD_MANAGEMENT_DECK = 'blood-management-deck',
  BLOOD_MANAGEMENT_DETAILS_CARD = 'blood-management-details-card',
  BLOOD_MANAGEMENT_FOOTER_PANEL = 'blood-management-footer-panel',
  BLOOD_MANAGEMENT_VIEWER_CONTEXTUAL_BAR = 'blood-management-viewer-contextual-bar',
  BLOOD_MANAGEMENT_VIEWER_LAYOUT = 'blood-management-viewer-layout',
  CONTEXTUAL_BAR_ACTION_ADJUST_SPEED = 'contextual-bar-action-adjust-speed',
  CONTEXTUAL_BAR_ACTION_RECORD_REACTION = 'contextual-bar-action-record-reaction',
  CONTEXTUAL_BAR_ACTION_REVERSE = 'contextual-bar-action-reverse',
  CONTEXTUAL_BAR_ACTION_SUSPEND = 'contextual-bar-action-suspend',
  CONTEXTUAL_BAR_ACTION_TERMINATE = 'contextual-bar-action-terminate',
  EXECUTE_TIME_PANEL = 'execute-time-panel',
  GLOBAL_ACTIONS = 'global-actions',
  INFORMATION_BAR_HEADER_FRAGMENT = 'information-bar-header-fragment',
  INTERRUPT_BUTTON = 'interrupt-button',
  PANEL_HEADER = 'panel-header',
  START_BUTTON = 'start-button',
}
export { BloodManagementViewerAliases };
